import { Card, Typography } from "@arco-design/web-react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

/** 快捷入口数据结构。 */
export interface QuickLinkItem {
  label: string;
  description: string;
  to: string;
}

/** 快捷入口面板。 */
export function QuickLinksPanel({ items }: { items: QuickLinkItem[] }) {
  return (
    <Card
      bodyStyle={{ padding: 22 }}
      style={{
        height: "100%",
        border: "1px solid #e5e6eb",
        borderRadius: 20,
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
      }}
    >
      <Title heading={5} style={{ marginTop: 0 }}>
        快捷入口
      </Title>
      <div style={{ display: "grid", gap: 12 }}>
        {items.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #e5e6eb",
              borderRadius: 16,
              padding: "16px 18px",
              color: "#1d2129",
              textDecoration: "none",
              transition: "border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease",
            }}
          >
            <div>
              <div style={{ marginBottom: 6, fontWeight: 600 }}>{item.label}</div>
              <Text style={{ color: "#86909c", fontSize: 13 }}>{item.description}</Text>
            </div>
            <ArrowRight size={18} />
          </Link>
        ))}
      </div>
    </Card>
  );
}
